import { shape, string } from 'prop-types';
import { ILabelValuePair } from 'types/shared';

type PeriodTypeLookup = { [key: string]: ILabelValuePair<string> };

const periodTypes: PeriodTypeLookup = {
  day: {
    label: 'View by day',
    value: 'day',
  },
  week: {
    label: 'View by week',
    value: 'week',
  },
  month: {
    label: 'View by month',
    value: 'month',
  },
  year: {
    label: 'View by year',
    value: 'year',
  },
};
/** This type is needed for Streaming Performance component for Tracks in compareMode */
export const additionalPeriodTypes: PeriodTypeLookup = {
  first8weeks: {
    label: 'View by First 8 Weeks',
    value: 'first8weeks',
  },
  weeks52: {
    label: 'View by 52 Weeks',
    value: 'weeks52',
  },
};

export const customDateType: PeriodTypeLookup = {
  customDate: {
    label: 'Custom Dates',
    value: 'customDate',
  },
};

export const periodPropType = shape({
  label: string,
  value: string,
});

export const audiencePeriodTypes: PeriodTypeLookup = {
  day: {
    label: 'View by last 30 days',
    value: 'day',
  },
  twoWeeks: {
    label: 'View by last 14 days',
    value: 'twoWeeks',
  },
};

export default periodTypes;
